import React from "react";

export default function BoardToolbar({ left, right, className = "" }) {
  return (
    <div
      className={[
        "mb-3 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between",
        className,
      ].join(" ")}
    >
      <div className="flex flex-wrap items-center gap-2">{left}</div>
      <div className="flex flex-wrap items-center gap-2">{right}</div>
    </div>
  );
}
